export enum WathiqErrorCode {
  AttemptsLimitExceeded = 40301,
  NoResultFound = 40421,
  FailedToIntegrate = 40302,
}
